import { storageNamespace } from './storage';

export default function registerServiceWorker() {
  const isCapacitor = typeof window.Capacitor !== 'undefined' || window.location.protocol === 'capacitor:';
  if (!('serviceWorker' in navigator) || isCapacitor) return;
  const register = () => {
    // Use the root worker even on direct /opinion/:id or /ru/login navigation.
    // Isolated builds preserve production caches and bypass them entirely.
    const address = storageNamespace
      ? `/service-worker.js?storageNamespace=${encodeURIComponent(storageNamespace)}`
      : '/service-worker.js';
    navigator.serviceWorker.register(address, { scope: '/', updateViaCache: 'none' }).catch(error => {
      console.log('ServiceWorker registration failed:', error);
    });
  };
  if (document.readyState === 'complete') register();
  else window.addEventListener('load', register, { once: true });
}
